<div class="home-cards" style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; justify-content: center; align-items: center; max-width: 800px; margin: 0 auto; padding: 2rem; height: 80vh;">
  <p-card [style]="{width: '380px', cursor: 'pointer', padding: '2rem'}" (click)="navigateTo('fleet-management')">
    <ng-template pTemplate="header">
      <h2 style="text-align: center; margin: 0;">Fleet Management</h2>
    </ng-template>
    <div style="text-align: center;">
      <i class="pi pi-box" style="font-size: 2rem; margin-bottom: 1rem;"></i>
      <p>Manage and assign your fleets</p>
    </div>
  </p-card>
  <p-card [style]="{width: '380px', cursor: 'pointer', padding: '2rem'}" (click)="navigateTo('software-updates')">
    <ng-template pTemplate="header">
      <h2 style="text-align: center; margin: 0;">Software Updates</h2>
    </ng-template>
    <div style="text-align: center;">
      <i class="pi pi-cloud-upload" style="font-size: 2rem; margin-bottom: 1rem;"></i>
      <p>View and upload software updates</p>
    </div>
  </p-card>
  <p-card [style]="{width: '380px', cursor: 'pointer', padding: '2rem'}" (click)="navigateTo('deploy-management')">
    <ng-template pTemplate="header">
      <h2 style="text-align: center; margin: 0;">Deploy Management</h2>
    </ng-template>
    <div style="text-align: center;">
      <i class="pi pi-send" style="font-size: 2rem; margin-bottom: 1rem;"></i>
      <p>Manage software deployments</p>
    </div>
  </p-card>
  <p-card [style]="{width: '380px', cursor: 'pointer', padding: '2rem'}" (click)="navigateTo('log-management')">
    <ng-template pTemplate="header">
      <h2 style="text-align: center; margin: 0;">Log Management</h2>
    </ng-template>
    <div style="text-align: center;">
      <i class="pi pi-list" style="font-size: 2rem; margin-bottom: 1rem;"></i>
      <p>View and analyze activity logs</p>
    </div>
  </p-card>
</div>
